var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "otp-verify-card" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column", staticStyle: { gap: "1rem" } },
      [
        _c(
          "FormGroup",
          {
            attrs: {
              "error-container": _vm.errorContainer,
              label: "Email address",
              name: "email",
              floating: true,
            },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email",
                },
              ],
              ref: "input",
              staticClass: "form-control",
              attrs: {
                id: _vm.id,
                readonly: _vm.meta.loading || _vm.meta.codeSent,
                name: "email",
                placeholder: " ",
                required: "",
                type: "email",
              },
              domProps: { value: _vm.form.email },
              on: {
                blur: function ($event) {
                  _vm.form.email = _vm.form.email.trim()
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.sendCode.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "email", $event.target.value)
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.meta.preventResend
          ? _c("TimeCountdown", {
              staticClass: "fm-resend-hint",
              attrs: {
                disabled: _vm.meta.loading,
                from: 60,
                "request-change-text": "Change Email",
              },
              on: {
                requestChange: _vm.onRequestEmailChange,
                resend: _vm.sendCode,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.meta.codeSent
          ? _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainer,
                  label: "Verification Code",
                  name: "code",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.code,
                      expression: "form.code",
                    },
                  ],
                  staticClass: "form-control otp-code-input",
                  attrs: {
                    id: _vm.codeId,
                    readonly: _vm.meta.loading,
                    name: "code",
                    required: "",
                    type: "text",
                    maxlength: "6",
                    placeholder: " ",
                    autocomplete: "one-time-code",
                  },
                  domProps: { value: _vm.form.code },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "code", $event.target.value)
                    },
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex gap-2 flex-wrap" }, [
          !_vm.meta.codeSent
            ? _c(
                "button",
                {
                  staticClass: "btn-fm btn-fm-primary",
                  attrs: { disabled: _vm.meta.loading, type: "button" },
                  on: { click: _vm.sendCode },
                },
                [
                  _vm.meta.loading
                    ? _c("SpinKit", { attrs: { loading: true } })
                    : _c("span", [_vm._v("Send Code")]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.meta.codeSent
            ? _c(
                "button",
                {
                  staticClass: "btn-fm btn-fm-primary",
                  attrs: { disabled: _vm.meta.loading, type: "button" },
                  on: { click: _vm.verifyCode },
                },
                [
                  _vm.meta.loading
                    ? _c("SpinKit", { attrs: { loading: true } })
                    : _c("span", [_vm._v("Verify Code")]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }